import { ApiResponse } from '@magnetar/admin-api-interfaces'
import { useAuth } from '@/hooks/useAuth'
import { useGet } from '@/hooks/useFetch'

interface ClinicQueueModuleStats {
  /** 已開啟叫號系統模組的診所數量 */
  enabled: number
  /** 未開啟叫號系統模組的診所數量 */
  disabled: number
}

interface UseClinicQueueModuleStatsParams {
  /** 帶入則只統計該 Provider 底下的診所；不帶則統計全部（sys_admin） */
  providerId?: number
}

export function useClinicQueueModuleStats({ providerId }: UseClinicQueueModuleStatsParams) {
  const { token } = useAuth()

  const params: Record<string, unknown> = {}
  if (providerId) params.providerId = providerId

  const { data, error, mutate } = useGet<ApiResponse<ClinicQueueModuleStats>>(
    token ? '/api/clinics/queue-module-stats' : null,
    params,
    token ?? '',
  )

  return {
    enabled: data?.data?.enabled ?? 0,
    disabled: data?.data?.disabled ?? 0,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
